import { homeSecurityPortalApi } from 'data/axios';
import { TPlanList, TSkipList, TSkipReason } from 'typings';
import { ApiResponse } from './HttpRequest';
import { PIGGYBANK_ENDPOINTS } from './endpoints';

export async function trailCamSkipFreeTrialReason(payload: TSkipReason) {
  const response = await homeSecurityPortalApi.post(
    PIGGYBANK_ENDPOINTS.TRAIL_CAM_USER_SKIP_REASON,
    payload
  );
  return response;
}

export async function trailCamSkipFreeTrialList(): Promise<
  ApiResponse<TSkipList[]>
> {
  const response = await homeSecurityPortalApi.get(
    PIGGYBANK_ENDPOINTS.TRAIL_CAM_TRIAL_SKIP_REASON
  );
  return response;
}

export async function getTrailCamPlans({
  country,
  sku_category
}: {
  country: string;
  sku_category: string;
}): Promise<ApiResponse<TPlanList[]>> {
  const response = await homeSecurityPortalApi.get(
    PIGGYBANK_ENDPOINTS.TRAIL_CAM_PLAN_LIST({ country, sku_category })
  );
  return response;
}
